export default __webpack_public_path__ + "static/media/tripAdvisor.35ae4167.svg";